import { Stack, TypographyPropsVariantOverrides } from '@mui/material'
import Label from 'components/Label'
import React from 'react'
import { OverridableStringUnion } from '@mui/types'
import { Variant } from '@mui/material/styles/createTypography'

type FieldProps = {
  label: string
  value: string[]
  direction: 'column' | 'row'
  variant?: OverridableStringUnion<Variant | 'inherit', TypographyPropsVariantOverrides>
}

export const Field: React.FC<FieldProps> = ({ label, value, direction, variant }) => {
  const directionProps = direction === 'row' ? { spacing: 1 } : null

  return (
    <Stack direction={direction} {...directionProps}>
      <Label text={label} bold v={variant || 'body1'} />
      {value &&
        value.map((item, index) => <Label key={index} text={item} v={variant || 'body1'} />)}
    </Stack>
  )
}
